import ArticleQuoteUI from "@business-finland/wif-ui-lib/dist/ArticleQuote";

import useImageDataHandler from "../../../hooks/useImageDataHandler";

interface MgnlArticleQuoteNode extends Wif.Mgnl.Node {
  name: string;
  quote: string;
  background:
    | {
        field: "image";
        image: Wif.Mgnl.Image;
        credits: string;
      }
    | {
        field: "color";
        color: {
          field: "lightBlue" | "lightGrey";
        };
      };
}

export default function ArticleQuote(node: MgnlArticleQuoteNode): JSX.Element {
  const { name, quote, background } = node;
  const imageDataHandler = useImageDataHandler();

  if (background.field === "image") {
    return (
      <div>
        <ArticleQuoteUI
          quote={quote}
          name={name}
          variant="image"
          imageData={imageDataHandler(background.image)}
          credits={background.credits}
        />
      </div>
    );
  }

  return (
    <div>
      <ArticleQuoteUI
        quote={quote}
        name={name}
        variant="color"
        color={background.color.field}
      />
    </div>
  );
}
